/* istanbul ignore file */
import { Typography } from '@mui/material';

/**
 * @param icon -- fa- prefixed classname for icon.
 * @param label
 * @returns {*}
 * @constructor
 */
interface ListHeaderProps {
  icon?: string;
  label: string;
}

const ListHeader = ({ icon, label }: ListHeaderProps) => {
  return (
    <Typography variant="h1" color="brand" mb={1.25} mt={{ xs: 0, md: '10px' }}>
      {label}
    </Typography>
  );
};

export default ListHeader;
